// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__zY34S","subTitle":"PageTitle_subTitle__5EIdE","actionButtons":"PageTitle_actionButtons__sd483"};